import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export const reactPlugin = new ReactPlugin();

let appInsights: ApplicationInsights;

export default function initAppInsights(
  appInsightsConnectionString?: string,
): ApplicationInsights | undefined {
  if (!appInsightsConnectionString) {
    return undefined;
  }
  if (appInsights) {
    return appInsights;
  }
  appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightsConnectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      disablePageUnloadEvents: ["unload", "beforeunload"],
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();

  return appInsights;
}
